import { cardColors, getTextColor } from './cardColors';

export default function CardList({ activeCard, onSelectCard, cardSelections }) {
  const cards = Array.from({ length: 20 }, (_, i) => String.fromCharCode(65 + i));

  return (
    <aside className="card-list">
      {cards.map(card => (
        <div
          key={card}
          className={`card-item ${card === activeCard ? 'active' : ''}`}
          onClick={() => onSelectCard(card)}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            backgroundColor: cardColors[card],
            color: getTextColor(cardColors[card]),
            fontWeight: 'bold'
          }}
        >
          {card}
        </div>
      ))}
    </aside>
  );
}